/* GRECO PAGES — small helpers for collection, product, supplier and contact pages.
   No dependencies. Safe to load once per page (guarded). */
(function () {
  'use strict';
  if (window.__grecoPages) return;
  window.__grecoPages = true;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var mobile = function () { return window.matchMedia('(max-width: 989px)').matches; };

  /* reveal on scroll */
  function reveal(root) {
    var els = $$('[data-gp-reveal]', root);
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e, i) { e.style.transitionDelay = Math.min(i % 4, 3) * 70 + 'ms'; io.observe(e); });
  }

  /* filters + sort */
  function facets(root) {
    var form = $('[data-gp-facets-form]', root);
    if (!form) return;
    var panel = $('.gp-facets', root), scrim = $('.gp-scrim', root);
    function submit() {
      var params = new URLSearchParams(new FormData(form));
      var clean = new URLSearchParams();
      params.forEach(function (v, k) { if (v !== '') clean.append(k, v); });
      window.location.search = clean.toString();
    }
    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-gp-sort]') || !mobile()) submit();
    });
    form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
    function open(on) {
      if (!panel) return;
      panel.classList.toggle('is-open', on);
      if (scrim) scrim.classList.toggle('is-open', on);
      document.documentElement.style.overflow = on ? 'hidden' : '';
    }
    $$('[data-gp-open-filters]', root).forEach(function (b) { b.addEventListener('click', function () { open(true); }); });
    $$('[data-gp-close-filters]', root).forEach(function (b) { b.addEventListener('click', function () { open(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') open(false); });
  }

  /* product gallery */
  function gallery(root) {
    var main = $('.gp-gallery__main', root);
    if (!main) return;
    var slides = $$('.gp-gallery__slide', main), thumbs = $$('.gp-gallery__thumb', root), count = $('.gp-gallery__count', root);
    var idx = 0, auto = false, autoT, settleT;
    function set(i, scroll, instant) {
      idx = Math.max(0, Math.min(slides.length - 1, i));
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === idx ? 'true' : 'false'); });
      if (count) count.textContent = (idx + 1) + ' / ' + slides.length;
      if (scroll) {
        auto = true; clearTimeout(autoT);
        autoT = setTimeout(function () { auto = false; }, instant ? 50 : 900);
        main.scrollTo({ left: slides[idx].offsetLeft, behavior: instant ? 'auto' : 'smooth' });
      }
    }
    // the visitor picked an image: tell the variant picker
    function picked() {
      var id = slides[idx] && slides[idx].dataset.mediaId;
      if (id && root.__gpPickVariantForMedia) root.__gpPickVariantForMedia(id);
    }
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { set(n, true); picked(); }); });
    var raf;
    main.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { set(Math.round(main.scrollLeft / main.clientWidth), false); });
      clearTimeout(settleT);
      settleT = setTimeout(function () { if (!auto) picked(); }, 160);
    }, { passive: true });
    root.__gpGoToMedia = function (id, instant) {
      slides.forEach(function (s, n) { if (s.dataset.mediaId === String(id) && n !== idx) set(n, true, instant); });
    };
    // lightbox
    var lb = $('.gp-lightbox', root);
    if (!lb) return;
    var img = $('img', lb);
    function show(i) { idx = (i + slides.length) % slides.length; var s = slides[idx].querySelector('img'); if (s) img.src = s.dataset.full || s.currentSrc || s.src; }
    function open(on) { lb.classList.toggle('is-open', on); document.documentElement.style.overflow = on ? 'hidden' : ''; if (on) show(idx); }
    $$('[data-gp-zoom]', root).forEach(function (b) { b.addEventListener('click', function () { open(true); }); });
    slides.forEach(function (s, n) { s.addEventListener('click', function () { if (!mobile()) { idx = n; open(true); } }); });
    $('[data-close]', lb).addEventListener('click', function () { open(false); });
    $('[data-prev]', lb).addEventListener('click', function () { show(idx - 1); });
    $('[data-next]', lb).addEventListener('click', function () { show(idx + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) open(false); });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') open(false); if (e.key === 'ArrowLeft') show(idx - 1); if (e.key === 'ArrowRight') show(idx + 1);
    });
  }

  /* variant picker (enquiry store: updates price label, SKU, image, URL, quote link) */
  function variants(root) {
    var dataEl = $('[data-gp-variants]', root);
    if (!dataEl) return;
    var list; try { list = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var fields = $$('[data-gp-option]', root);
    var priceEl = $('[data-gp-price]', root), skuEl = $('[data-gp-sku]', root), quotes = $$('[data-gp-quote]', root);
    var title = root.dataset.productTitle || '';
    function current() {
      return fields.map(function (f) { var c = $('input:checked', f); return c ? c.value : null; });
    }
    var first = true, fromImage = false;
    function update() {
      var sel = current();
      fields.forEach(function (f, i) { var b = $('legend b', f); if (b) b.textContent = sel[i] || ''; });
      var v = list.filter(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); })[0];
      // mark combinations that don't exist
      fields.forEach(function (f, i) {
        $$('.gp-opt', f).forEach(function (o) {
          var val = $('input', o).value;
          var ok = list.some(function (x) { return x.options[i] === val && x.options.every(function (y, j) { return j === i || y === sel[j]; }); });
          o.classList.toggle('is-na', !ok);
        });
      });
      if (!v) return;
      if (priceEl) priceEl.innerHTML = v.price_html;
      if (skuEl) { skuEl.textContent = v.sku ? 'SKU ' + v.sku : ''; }
      if (v.media && root.__gpGoToMedia && !fromImage) root.__gpGoToMedia(v.media, first);
      var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString());
      quotes.forEach(function (q) {
        try { var qu = new URL(q.href, location.origin); qu.searchParams.set('product', title + (list.length > 1 ? ' (' + v.title + ')' : '')); q.href = qu.pathname + qu.search; } catch (e) {}
      });
    }
    root.addEventListener('change', function (e) { if (e.target.closest('[data-gp-option]')) update(); });
    // an image was picked in the gallery: select the variant that uses it
    root.__gpPickVariantForMedia = function (id) {
      var sel = current();
      var matches = list.filter(function (x) { return String(x.media) === String(id); });
      if (!matches.length) return;
      if (matches.some(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); })) return;
      // keep the visitor's other choices (e.g. size) when possible
      var score = function (x) { return x.options.filter(function (o, i) { return o === sel[i]; }).length; };
      var best = matches.slice().sort(function (a, b) { return score(b) - score(a); })[0];
      fields.forEach(function (f, i) {
        $$('input', f).forEach(function (inp) { inp.checked = inp.value === best.options[i]; });
      });
      fromImage = true; update(); fromImage = false;
    };
    update(); first = false;
  }

  /* supplier directory: highlight current category chip */
  function directory(root) {
    var chips = $$('[data-gp-jump]', root);
    if (!chips.length || !('IntersectionObserver' in window)) return;
    var map = {};
    chips.forEach(function (c) { map[c.getAttribute('href').slice(1)] = c; });
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        if (!e.isIntersecting) return;
        chips.forEach(function (c) { c.classList.remove('is-on'); });
        var c = map[e.target.id];
        if (c) { c.classList.add('is-on'); var bar = c.closest('.gp-chips'); if (bar) bar.scrollTo({ left: c.offsetLeft - bar.clientWidth / 2 + c.offsetWidth / 2, behavior: 'smooth' }); }
      });
    }, { rootMargin: '-35% 0px -60% 0px' });
    $$('.gp-cat[id]', root).forEach(function (s) { io.observe(s); });
  }

  /* contact: prefill product enquiry + highlight today's hours */
  function guessProject(t) {
    t = t.toLowerCase();
    if (/vinyl|spc|lvp|lvt|luxury plank|rigid core/.test(t)) return 'Vinyl';
    if (/laminate/.test(t)) return 'Laminate';
    if (/carpet|broadloom|rug/.test(t)) return 'Carpet';
    if (/backsplash|mosaic/.test(t)) return 'Backsplash';
    if (/tile|porcelain|ceramic|marble|slab|zellige|stone/.test(t)) return 'Tile';
    if (/hardwood|engineered|oak|maple|hickory|walnut|wood/.test(t)) return 'Hardwood';
    return '';
  }
  function contact(root) {
    var form = $('#GpContact', root);
    if (form) {
      var p = new URLSearchParams(location.search).get('product');
      if (p) {
        var body = $('textarea', form), hidden = $('[data-gp-product]', form), type = $('select', form);
        if (hidden) hidden.value = p;
        if (body && !body.value) body.value = "Hi, I'm interested in " + p + '. Could you tell me more about pricing and availability?\n\n';
      }
      // choose the matching project type (from ?project=, else guessed from the product name)
      var sel = $('select', form), proj = new URLSearchParams(location.search).get('project') || guessProject(p || '');
      if (sel && proj) {
        var want = proj.toLowerCase();
        [].some.call(sel.options, function (o) { if (o.value.toLowerCase() === want || o.text.toLowerCase() === want) { sel.value = o.value; return true; } return false; });
      }
    }
    var d = new Date().getDay(); // 0 = Sunday
    var names = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
    $$('.gp-hours tr', root).forEach(function (tr) {
      var k = (tr.dataset.day || '').slice(0, 3).toLowerCase();
      if (k === names[d]) tr.classList.add('is-today');
    });
  }

  function init(root) {
    root = root || document;
    reveal(root); facets(root); directory(root); contact(root);
    $$('[data-gp-product-root]', root).forEach(function (r) { gallery(r); variants(r); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
